import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  isLargeScreen,
  updateCustomTableHeaders,
} from '../../../../../global.variable';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { ClientsService } from '../../clients/clients.service';
import { getDateTimeRange } from '../../tableDetails';
import { UsersService } from '../../users/users.service';
import { SubContactorsService } from '../../sub-contractors/sub-contactors.service';
import { JobsService } from '../../jobs/jobs.service';

@Component({
  selector: 'gtapp-jobs-report',
  standalone: false,
  templateUrl: './jobs-report.component.html',
  styleUrl: './jobs-report.component.scss',
})
export class JobsReportComponent implements OnInit, OnDestroy {
  largeView: Boolean = isLargeScreen;
  jobReportTypes = ['Completed', 'Cancelled'];

  jobReportAdditionalInfo: any = {};
  selectedJobReportType: 'Completed' | 'Cancelled' = 'Completed';

  allowBillingReportExport: boolean = false;
  jobReportDataList: any = [];
  preLoadedData: any = {};

  sortKeys: any = ['modified_date'];

  jobDefaultTimeRange = getDateTimeRange();
  selectedSubUserId: string = '';

  searchParams: any = {
    modified_date__range: [
      this.jobDefaultTimeRange?.dateRange?.start,
      this.jobDefaultTimeRange?.dateRange?.end,
    ],
  };

  totalRows: number = 0;
  previous: number = 0;
  pageSize: number = 15;
  pageNum: number = 1;
  totalPages: number = 0;

  otherParams: any = {
    apiFiltering: true,
  };

  jobReportDetailsTableView: any = [];
  jobReportDetailsMobileView: any = {};

  initialDataList: any = {};
  siteListData: any = [];
  clientDropDownList: any = [];
  subContractorDataList: any = [];
  jobTypesDataList: any = [];

  selectedClient: any = {};
  selectedSite: any = {};
  selectedSubContactor: any = {};
  selectedJobType: any = {};

  constructor(
    private userService: UsersService,
    private spinnerService: LoadingSpinnerService,
    private dialogService: ModalDialogueService,
    private toasterService: ToasterService,
    private route: ActivatedRoute,
    private router: Router,
    private clientService: ClientsService,
    private contractorService: SubContactorsService,
    private jobService: JobsService,
  ) {
    this.formatRouteUrl();
    this.getTableDetails();
  }
  ngOnDestroy(): void {}
  ngOnInit(): void {
    this.getJobTypes(); // will call the event log data also with default static shifts
    this.searchClients('');
    this.onSubContractorSearch();
    // this.getEventLogData();
  }

  getEventLogData() {
    this.spinnerService.show();
    let body = this.getApiRequestBody();
    this.userService.getUserUpdateLog(body).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.allowBillingReportExport = true;
        this.spinnerService.hide();
        this.totalRows = response['total_size'];
        this.otherParams.paginationData = {
          totalRows: this.totalRows,
          previousRows: this.previous,
          rows: this.pageSize,
          pageNum: this.pageNum,
          totalPages: Math.ceil(this.totalRows / this.pageSize),
        };
        this.otherParams = { ...this.otherParams };
        this.jobReportDataList = response?.data;
        this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        const jobIds = [
          ...new Set(response?.data?.map((item: any) => item?.id)),
        ];
        if (jobIds?.length) this.getJobReportAdditionalInfo(jobIds);

        this.preLoadNextPageData();
        this.updateRoutPath();
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
        this.spinnerService.hide();
      }
    });
  }
  updateRoutPath() {
    this.router.navigate([], {
      fragment: btoa(
        JSON.stringify({
          searchParams: this.searchParams,
          otherParams: this.otherParams,
          pageSource: 'job-reports',
          selectedJobReportType: this.selectedJobReportType,
          selectedClient: this.selectedClient,
          selectedSite: this.selectedSite,
          selectedSubContactor: this.selectedSubContactor,
          selectedJobType: this.selectedJobType,
        }),
      ),
      queryParams: {},
      replaceUrl: true, // Replaces the current URL without adding a new history entry
    });
  }
  jobReportSelectRadio(event: any) {
    this.jobReportDataList = [];
    this.clearPagination();

    this.selectedJobReportType = event.target.value;
    if (this.selectedJobReportType === 'Completed') {
      this.searchParams = {};
      this.sortKeys = ['modified_date'];
      this.jobReportDetailsTableView = this.getJobReportDesktopDetailParams();
      this.jobReportDetailsMobileView = this.getJobReportMobileDetailParams();
    } else {
      this.searchParams = {};
      this.jobReportDetailsMobileView =
        this.getJobReportMobileDetailParams('cancelled');
      this.sortKeys = ['modified_date'];

      this.jobReportDetailsTableView =
        this.getJobReportDesktopDetailParams('cancelled');
    }
    this.searchParams = {
      modified_date__range: [
        this.jobDefaultTimeRange?.dateRange?.start,
        this.jobDefaultTimeRange?.dateRange?.end,
      ],
    };

    this.getEventLogData();
  }
  mailBillingReport() {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Send Report to your email',
      },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value === true) {
        this.spinnerService.show();

        let body: any = this.getApiSearchBody();

        body.export_type = 'csv';

        this.userService.exportUserUpdateLog(body).then((response: any) => {
          if (response['status'] == 'success') {
            this.toasterService.setMessage({
              successMessage: response['message'],
              errorMessage: '',
            });

            this.spinnerService.hide();
          } else {
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
            this.spinnerService.hide();
          }
        });
      }
    });
  }
  onJobTableRowClick(event: any) {
    this.spinnerService.show();

    this.router.navigate([`/job-review/${event?.job_key}`], {
      queryParams: { jId: event?.id },
    });
  }
  getJobReportAdditionalInfo(jobIds: any) {
    const body = {
      event_type: 'job_report',
      job_report_type: this.selectedJobReportType?.toLowerCase(),
      job_ids: jobIds,
    };
    this.userService
      .getUserUpdateLog(body, { get_job_additional_info: 1 })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.jobReportAdditionalInfo = {
            ...response?.data,
            ...this.jobReportAdditionalInfo,
          };
          this.otherParams = { ...this.otherParams };
        }
      });
  }
  getJobReportMobileDetailParams(
    reportType: 'completed' | 'cancelled' = 'completed',
  ) {
    let individualDetails: any = [
      {
        name: 'job_type',
        cardRowStyle: {
          'font-size': 'small',
        },
      },

      {
        name: 'site_name',
        cardRowStyle: { 'font-weight': 'bold' },
        suffixStyle: { 'font-weight': 'normal' },
        suffixNestedValue: (row: any) => {
          return ` [${row?.company_name}]`;
        },
      },

      {
        name: 'site_address',
        cardRowStyle: { 'font-size': 'small' },
      },

      {
        nestedValue: (row: any) => {
          if (row?.ext_job_id) {
            return `${row?.job_key} [${row?.ext_job_id}]`;
          } else {
            return row?.job_key;
          }
        },
        cardRowStyle: {
          'font-size': 'small',
        },
      },
      {
        name: 'assignee',
        cardRowStyle: { 'font-size': 'small' },
      },
    ];
    if (reportType === 'completed') {
      individualDetails.push({
        prefix: 'Completed: ',
        nestedValue: (row: any) => {
          return this.jobReportAdditionalInfo?.[row?.id]?.completed_time;
        },
        header: 'Date',
        datetimeObj: true,
        dateRangeKey: 'modified_date',
        ...this.jobDefaultTimeRange,
        cardRowStyle: {
          'font-size': 'small',
        },
      });
    } else {
      individualDetails.push({
        prefix: 'Cancelled: ',
        nestedValue: (row: any) => {
          return this.jobReportAdditionalInfo?.[row?.id]?.cancelled_time;
        },
        header: 'Date',
        datetimeObj: true,
        dateRangeKey: 'modified_date',
        ...this.jobDefaultTimeRange,
        cardRowStyle: {
          'font-size': 'small',
        },
      });
    }
    return { individualDetails: individualDetails };
  }
  getJobReportDesktopDetailParams(
    reportType: 'completed' | 'cancelled' = 'completed',
  ) {
    return reportType === 'completed'
      ? [
          {
            header: 'Date',
            sortKey: 'modified_date',
            name: 'modified_date',
            dateRangeKey: 'modified_date',
            datetimeObj: true,
            ...this.jobDefaultTimeRange,
            dateTimeFormat: 'd-MMM yyyy',
            permanent: true,
            sortOrder: 'asc',
          },
          {
            header: 'Completed',
            nestedValue: (row: any) => {
              return this.jobReportAdditionalInfo?.[row?.id]?.completed_time;
            },
            datetimeObj: true,
            dateTimeFormat: 'd-MMM yyyy',
          },
          {
            header: 'Site',
            sortKey: 'site_name',
            name: 'site_name',
            tableColumnStyle: {
              'white-space': 'pre-line',
            },
            suffixNestedValue: (row: any) => {
              return ` \n ${row?.site_address} \n[${row?.company_name}]`;
            },
            suffixStyle: { 'font-size': '0.8rem' },

            autoComplete: 'site',
          },

          {
            header: 'Docket No.',
            sortKey: 'job_key',
            searchKey: 'job_key',
            tableColumnStyle: {
              'white-space': 'pre-line',
            },
            nestedValue: (row: any) => {
              let appendList = [row?.job_key];
              if (row?.ext_job_id) appendList.push(`[${row?.ext_job_id}]`);
              appendList.push(row?.job_type);

              return appendList.join('\n');
            },
          },

          {
            header: 'Onsite',
            nestedValue: (row: any) => {
              return this.jobReportAdditionalInfo?.[row?.id]?.onsite_time;
            },
            datetimeObj: true,
          },
          {
            header: 'Offsite',
            nestedValue: (row: any) => {
              return this.jobReportAdditionalInfo?.[row?.id]?.offsite_time;
            },
            datetimeObj: true,
          },
          {
            header: 'Time Onsite(min)',
            nestedValue: (row: any) => {
              return this.jobReportAdditionalInfo?.[row?.id]?.onsite_minutes;
            },
          },
          {
            header: 'Add. Info.',
            name: 'additional_information',
            columnDataStyle: {
              'white-space': 'pre-line',
              'font-size': 'small',
            },
          },
          {
            header: 'Guard',
            name: 'assignee',
          },
        ]
      : [
          {
            header: 'Cancelled',
            sortKey: 'modified_date',
            dateRangeKey: 'modified_date',
            name: 'modified_date',
            datetimeObj: true,
            ...this.jobDefaultTimeRange,
          },
          {
            header: 'Site',
            sortKey: 'site_name',
            name: 'site_name',

            tableColumnStyle: {
              'white-space': 'pre-line',
            },
            suffixNestedValue: (row: any) => {
              return ` \n ${row?.site_address} \n[${row?.company_name}]`;
            },
            suffixStyle: { 'font-size': '0.8rem' },
          },

          {
            header: 'Docket No.',
            sortKey: 'job_key',
            searchKey: 'job_key',
            tableColumnStyle: {
              'white-space': 'pre-line',
            },
            nestedValue: (row: any) => {
              let appendList = [row?.job_key];
              if (row?.ext_job_id) appendList.push(`[${row?.ext_job_id}]`);
              appendList.push(row?.job_type);

              return appendList.join('\n');
            },
          },

          {
            header: 'Cancel Reason',
            nestedValue: (row: any) => {
              let sortedComments = this.jobReportAdditionalInfo?.[
                row?.id
              ]?.job_comments?.sort(
                (a: any, b: any) =>
                  new Date(a?.comment_time).getTime() -
                  new Date(b?.comment_time).getTime(),
              );
              let comments = sortedComments?.map(
                (commentObj: any) => commentObj?.comment,
              );
              return comments?.length > 0 ? comments[comments.length - 1] : '';
            },
          },

          {
            header: 'Add. Info.',
            name: 'additional_information',
            columnDataStyle: {
              'white-space': 'pre-line',
              'font-size': 'smaller',
            },
          },
          {
            header: 'Guard',
            name: 'assignee',
          },
        ];
  }

  preLoadNextPageData() {
    if (this.pageNum < this.totalPages) {
      let body = this.getApiRequestBody();
      body.previous = (body?.previous || 0) + this.pageSize;
      // implies there is one more page to load
      this.userService.getUserUpdateLog(body).subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.preLoadedData[this.pageNum + 1] = response?.data;

          const jobIds = [
            ...new Set(response?.data?.map((item: any) => item?.id)),
          ];
          if (jobIds?.length) this.getJobReportAdditionalInfo(jobIds);
        }
      });
    }
  }
  getApiSearchBody() {
    let body: any = {
      time_offset: new Date().getTimezoneOffset(),
      event_type: 'job_report',
      job_report_type: this.selectedJobReportType?.toLowerCase(),
    };
    let searchParams: any = { ...(this.searchParams || {}) };
    if (this.selectedClient?.id) {
      searchParams = {
        ...(searchParams || {}),
        company__company_name__icontains: this.selectedClient?.company_name,
        company_id: this.selectedClient?.id,
      };
    }
    if (this.selectedSite?.id) {
      searchParams = {
        ...(searchParams || {}),
        site__company_name__icontains: this.selectedSite?.company_name,
        site__id: this.selectedSite?.id,
      };
    }
    if (this.selectedJobType?.id) {
      searchParams = {
        ...(searchParams || {}),
        job_type_id: this.selectedJobType?.id,
      };
    }
    if (this.selectedSubContactor?.id)
      body.sub_contractor_id = this.selectedSubContactor?.id;

    if (this.sortKeys) body.sort_key = this.sortKeys;
    if (searchParams) {
      body.search_filters = searchParams;
    }
    return body;
  }
  getApiRequestBody() {
    let body: any = this.getApiSearchBody();

    if (this.pageSize) body.rows = this.pageSize;
    if (this.previous) body.previous = this.previous;

    return body;
  }
  onChangePagination(data: any) {
    this.previous = data?.paginationData?.previousRows;
    this.pageNum = data?.paginationData?.pageNum;

    if (data?.paginationData?.rows == this.pageSize) {
      this.pageSize = data?.paginationData?.rows;
      // do preloading only here
      if (this.preLoadedData?.[this.pageNum]) {
        this.otherParams.paginationData = {
          totalRows: this.totalRows,
          previousRows: this.previous,
          rows: this.pageSize,
          pageNum: this.pageNum,
          totalPages: Math.ceil(this.totalRows / this.pageSize),
        };

        this.jobReportDataList = this.preLoadedData?.[this.pageNum];

        this.totalPages = Math.ceil(this.totalRows / this.pageSize);
        const nextPage = this.pageNum + 1;
        this.updateRoutPath();
        if (!this.preLoadedData?.[nextPage]) this.preLoadNextPageData();
      } else {
        this.getEventLogData();
        this.otherParams.paginationData = { ...data?.paginationData };
      }
    } else {
      this.preLoadedData = {};
      this.pageSize = data?.paginationData?.rows;
      this.getEventLogData();
      this.otherParams.paginationData = { ...data?.paginationData };
    }
  }

  sortColumn(body: any) {
    this.clearPagination();
    this.sortKeys = body?.sortList || [];

    this.searchParams = body?.searchParams || {};
    if (body?.site_id) {
      this.searchParams = { ...this.searchParams, site_id: body?.site_id };
    }

    this.getEventLogData();
  }
  clearPagination() {
    this.preLoadedData = {};
    this.totalRows = 0;
    this.previous = 0;
    this.pageSize = 10;
    this.pageNum = 1;
    this.totalPages = 0;
    this.otherParams.paginationData = {
      totalRows: 0,
      previousRows: this.previous,
      rows: this.pageSize,
      pageNum: this.pageNum,
      totalPages: this.totalPages,
    };
  }
  searchColumn(event: any) {
    this.clearPagination();

    this.searchParams = event?.searchParams || {};

    if (event?.site_id) {
      this.searchParams = { ...this.searchParams, site_id: event?.site_id };
    }
    this.getEventLogData();
  }

  formatRouteUrl() {
    if (!this.route.snapshot.fragment) return;
    try {
      const urlFragmentDetails = JSON.parse(atob(this.route.snapshot.fragment));

      if (
        urlFragmentDetails &&
        Object.keys(urlFragmentDetails)?.length &&
        urlFragmentDetails?.pageSource == 'job-reports'
      ) {
        this.searchParams = {
          ...this.searchParams,
          ...(urlFragmentDetails?.searchParams || {}),
        };
        this.selectedJobReportType =
          urlFragmentDetails?.selectedJobReportType || 'Completed';

        this.selectedClient = urlFragmentDetails?.selectedClient || {};
        this.selectedSite = urlFragmentDetails?.selectedSite || {};
        this.selectedJobType = urlFragmentDetails?.selectedJobType || {};
        this.selectedSubContactor =
          urlFragmentDetails?.selectedSubContactor || {};

        if (urlFragmentDetails?.otherParams?.paginationData) {
          this.previous =
            urlFragmentDetails?.otherParams?.paginationData?.previousRows ||
            this.previous;
          this.pageNum =
            urlFragmentDetails?.otherParams?.paginationData?.pageNum ||
            this.pageNum;
          this.pageSize =
            urlFragmentDetails?.otherParams?.paginationData?.rows ||
            this.pageSize;
        }
      }
    } catch (error) {}
  }
  getTableDetails() {
    let tableDetails: any =
      this.selectedJobReportType === 'Completed'
        ? this.getJobReportDesktopDetailParams()
        : this.getJobReportDesktopDetailParams('cancelled');
    updateCustomTableHeaders(tableDetails, this.searchParams);
    if (this.selectedJobReportType === 'Completed') {
      this.jobReportDetailsTableView = tableDetails;
      this.jobReportDetailsMobileView = this.getJobReportMobileDetailParams();
    } else {
      this.jobReportDetailsTableView = tableDetails;
      this.jobReportDetailsMobileView =
        this.getJobReportMobileDetailParams('cancelled');
    }
  }
  editField(field: string) {
    if (field == 'subContractor') {
      this.selectedSubContactor = {};
      this.shiftFocus('subContractorLookupId');
    }
    if (field == 'jobType') {
      this.selectedJobType = { id: '' };
      this.shiftFocus('jobTypeSelectFieldId');
      return;
    }
    if (field == 'site') {
      this.selectedSite = {};
      this.shiftFocus('siteId');
    }
    if (field == 'client') {
      this.selectedClient = {};
      this.selectedSite = {};
      this.shiftFocus('clientLookupId');
    }

    this.updateInitialDataList(field);
    this.clearPagination();
    this.getEventLogData();
  }
  inputFocused(field: string) {
    this.updateInitialDataList(field);
  }
  shiftFocus(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 200);
  }
  updateInitialDataList(field: any) {
    this.siteListData = [];
    this.clientDropDownList = [];
    setTimeout(() => {
      if (field === 'site') {
        this.siteListData = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      } else if (field === 'client') {
        this.clientDropDownList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      } else if (field === 'client') {
        this.clientDropDownList = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      }
    }, 200);
  }

  onClientSearch(event: any) {
    if (event.target.value.length > 2) {
      this.searchClients(event.target.value);
    }
  }
  searchClients(searchStr?: any) {
    this.clientService.searchClients(searchStr).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.clientDropDownList = res?.data;
        if (!searchStr) {
          this.initialDataList.client = JSON.parse(
            JSON.stringify(this.clientDropDownList),
          );
        }
      }
    });
  }
  resetFilter() {
    this.clearPagination();
    this.getEventLogData();
  }
  onClientSelect(data: any) {
    this.selectedClient = data;
    this.selectedSite = {};
    this.onSiteSearch('');
    this.resetFilter();
  }
  onSiteSearch(event?: any) {
    const searchString = event ? event.target.value : '';

    let params: any = {
      company: this.selectedClient?.id,
      rows: 15,
      search_str: searchString,
    };

    this.clientService.getSiteList(params).subscribe((response: any) => {
      this.siteListData = response?.data || [];

      if (!event) {
        this.initialDataList.site = JSON.parse(
          JSON.stringify(this.siteListData),
        );
      }
    });
  }
  onSelectSite(data: any) {
    this.selectedSite = data;
    this.resetFilter();
  }
  onSubContractorSelect(event: any) {
    this.selectedSubContactor = event;
    this.resetFilter();
  }
  onSubContractorSearch(event?: any) {
    let params: any = { rows: 10, order_by: 'company_name' };
    if (event && event?.target.value?.length < 2) return;

    if (event?.target?.value) {
      params['search_str'] = event?.target.value;
    }

    this.contractorService.getContactors(params).then((response: any) => {
      this.subContractorDataList = response?.data || [];
      if (!event) {
        this.initialDataList.subContractor = JSON.parse(
          JSON.stringify(response?.data || []),
        );
      }
    });
  }
  onSelectJobType(event: any) {
    this.selectedJobType = this.jobTypesDataList?.find(
      (item: any) => item?.id == event.target.value,
    );

    if (!this.selectedJobType?.id) this.selectedJobType = { id: '' };

    this.resetFilter();
  }
  getJobTypes() {
    this.jobService.getJobParams().subscribe((response: any) => {
      this.jobTypesDataList = (response?.data || [])?.filter(
        (item: any) => ![4].includes(item?.type_identity),
      );
      if (!('id' in this.selectedJobType))
        this.selectedJobType = this.jobTypesDataList?.find(
          (item: any) => item?.type_identity == 2, // by default show static guards
        );

      this.resetFilter();
    });
  }
}
